import { useDispatch } from 'react-redux';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import React, { useEffect } from 'react';

const EmailRetrieveQuote = ({ fields }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isEditorActive()) {
      if (fields.dispatchType?.value && fields.dispatchPayload?.value) {
        const dispData = {
          type: fields.dispatchType?.value,
          payload: JSON.parse(fields.dispatchPayload?.value),
        };
        dispatch(dispData);
      }
    }
  }, []);

  return <></>;
};

export default EmailRetrieveQuote;
